export default __webpack_public_path__ + "static/media/fsi4.82d989dc.gif";